var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM12 4.34961C7.77502 4.34961 4.34961 7.77502 4.34961 12C4.34961 16.225 7.77502 19.6504 12 19.6504C16.225 19.6504 19.6504 16.225 19.6504 12C19.6504 7.77502 16.225 4.34961 12 4.34961ZM12 5.9248C12.3727 5.9248 12.6746 6.227 12.6748 6.59961V12.1699L15.1777 14.6729C15.4409 14.9363 15.4409 15.3634 15.1777 15.627C14.9141 15.8906 14.4863 15.8906 14.2227 15.627L11.5225 12.9277C11.3959 12.8012 11.3252 12.6291 11.3252 12.4502V6.59961C11.3254 6.227 11.6273 5.9248 12 5.9248Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockDelivery);
export default __webpack_public_path__ + "static/media/clock-delivery.30e7fb2f2752ff2715a7a0413bfee37b.svg";
export { ForwardRef as ReactComponent };